<div class="dashboard-container">
    <div class="column-1">
        <div class="general-statistics">
            <statistic-box [data]="routingAttemptsData"></statistic-box>
            <statistic-box [data]="nodesData"></statistic-box>
            <statistic-box [data]="usersData"></statistic-box>
            <statistic-box [data]="routersData"></statistic-box>
        </div>

        <div class="routing-attempts-statistics">
            <information-box [title]="'Routing Attempts'"
                             [subTitle]="'Per 5 min'"
                             [icon]="'fa-line-chart'"
                             (navigate)="navigateToRoutingAttempts()">
                <div class="chart-container" *ngIf="routingAttemptsChartOptions">
                    <arm-highchart #routingAttemptsChart [options]="routingAttemptsChartOptions"></arm-highchart>
                </div>
            </information-box>
        </div>

        <div class="routing-and-alarms-statistics">
            <information-box [title]="'Top Routing Matches'"
                             [subTitle]="'Last 3H'"
                             [icon]="'fa-bar-chart'"
                             (navigate)="navigateToTopRouting()">
                <div class="chart-container" *ngIf="topRoutingChartOptions">
                    <arm-highchart #topRoutingChart [options]="topRoutingChartOptions"></arm-highchart>
                </div>
            </information-box>

            <information-box [title]="'Active Alarms'"
                             [icon]="'fa-bell'"
                             (navigate)="navigateToActiveAlarms()">
                <active-alarms [items]="activeAlarmsCount"></active-alarms>
            </information-box>
        </div>
    </div>

    <div class="column-2">
        <div class="topology-info">
            <information-box [title]="'Topology Map'"
                             [subTitle]="'Last 3H'"
                             [icon]="'fa-map'"
                             (navigate)="navigateToNetwork()">
                <top-routes></top-routes>
            </information-box>
        </div>

        <div class="updates">
            <info-box></info-box>
        </div>
    </div>
</div>
